import AOS from 'aos';

// Fix for Safari back button cache issue with playing video
window.onpageshow = function (event) {
  if (event.persisted) {
      window.location.reload();
  }
};

function initAOS() {
  AOS.init({
    once: true,
    offset: 100,
  });
}

function refreshAOSOnScroll() {
  AOS.refresh();
}

function setAOSAnimationReady() {
  $(this).addClass('aos-animation-ready');
}

function adjustAOSForMobile() {
  if ($(window).width() < 992) {
    $('main.main section:lt(3)').each(function(){
      $(this).find('[data-aos]').attr('data-aos-offset', '-100');
    });
  }
}

$(document).ready(function() {
  initAOS(); // Initialize AOS after document ready
  adjustAOSForMobile(); // Adjust AOS for mobile
});

// Refresh AOS on scroll
$(window).on('scroll', refreshAOSOnScroll);

// Set transition delay to zero on mouseover
$(document).on('mouseover', '.aos-animate.aos-init', setAOSAnimationReady);

// Initialize AOS immediately to handle any issues with immediate effect
initAOS();
